import React from 'react'

function ViewReport() {
  return (
    <div>
      
    </div>
  )
}

export default ViewReport
